import { Lipsync } from 'wawa-lipsync';

// Single shared analyser. The TTS hook calls connectAudio(audioEl) each time it
// creates a fresh <audio> to play; the Avatar's useFrame calls processAudio()
// every frame and reads .viseme to drive the current mouth shape.
export const lipsyncManager = new Lipsync({});
